import { TranslatedPair } from './translations';
import { FormErrors } from '../../../constants';

// the formErrors is initialized in App.tsx
export const formTranslations: { errors?: FormErrors } = {};

// route name translations
export const routeNames: { nameText?: TranslatedPair } = {};

// user roles translations
export const userRolesTranslations: { role?: TranslatedPair } = {};
